<template>
  <div class="grid pb-0">
    <div class="border-top-unset">
      <v-progress-linear
        color="warning"
        indeterminate
        rounded
        height="3"
        v-if="isLoading"
      ></v-progress-linear>
        <div class="d-content-mobile">
            <label class="s-label">{{ $t("ROOM_CLASS") }}</label>
            <v-select
                item-text="text"
                item-value="value"
                :items="listRoom"
                v-model="selectedRoom"
                outlined
                dense
                @change="changeSearchCondition(selectedDatePicker)"
            >
                <template slot="no-data">
                <div class="no-data">{{ $t("NO_DATA") }}</div>
                </template>
            </v-select>
            <div class="mt-5">

                <FunctionalCalendar 
                    v-model="calendarData" 
                    :disabled-dates="calendarConfigs.disabledDates" 
                    :is-multiple="true" 
                    :is-date-range="false" 
                    :date-format="'yyyy/mm/dd'"
                    :calendars-count="1" 
                    @choseDay="chooseDate($event)"
                    @changedMonth="changedMonth($event)" 
                    @changedYear="changedMonth($event)" 
                    :dayNames="calendarConfigs.dayNames" 
                    :monthNames="calendarConfigs.monthNames" 
                    :shortMonthNames="calendarConfigs.shortMonthNames" 
                    :change-month-function='true' 
                    :change-year-function='true'>
					<template v-slot:default="props">
						<span class="d-date-day fs-16 ">{{ props.day.day < 10 ?  '0'+props.day.day : props.day.day }}</span>
						<div class="quantity text-center" :class="getClass(getValue(props.day.date))" @click="chooseDate(props.day)">
							<span v-if="getValue(props.day.date) > -1" class="fs-10 font-weight-bold">{{getValue(props.day.date)}}</span>
						</div>
				    </template>
				</FunctionalCalendar>

            </div>
            <div class="d-note-action"> 
                <ul class="pl-0">
                    <li>
                    <span
                        class="i-square d-little"
                        style="border-radius: 2px"
                    >
                       {{' < 10'}}
                    </span>
                    <span
                        class="i-square d-much"
                        style="border-radius: 2px"
                        >10 - 20</span
                    >
                    <span
                        class="i-square d-most"
                        style="border-radius: 2px"
                        >{{' > 20'}}</span
                    >
                    <span class="fs-10">{{ $t("ROOM_ARE_AVAILABLE_FROM_LESS_TO_MORE") }}</span>
                    </li>
                </ul>
                <div v-if="checkRoleFunc('INVENTORY')">
                    <v-btn depressed color="primary" class="fs-10 w-100" @click="openUpdateRange"> {{$t('UPDATE_ROOM_AVAILABILITY_IN_STAGES')}} </v-btn>
                </div>
            </div>
        </div>
    </div>
    <div id="overlay" @click="closeNav()"></div>
    <div id="my-update" class="sidenav-search">
        <v-toolbar class="toolbar-update" dense >
            <v-toolbar-title class="text-primary fs-15">
                <strong>{{$t('UPDATE_FOR', {date: _moment(new Date(dateUpdate)).format("DD/MM/YYYY")})}}</strong>
            </v-toolbar-title>
            <v-spacer></v-spacer>
            <v-btn icon light @click="closeNav()" >
                <v-icon color="primary">
                close
                </v-icon>
          </v-btn>
        </v-toolbar>
        <div class="content-update">
            <p class="mb-0"><span class="font-weight-bold">{{ $t("_ROOM_SALE.ROOM_TYPE.ROOM_TYPE") }}: </span>{{listRoom.find(e => e.value === selectedRoom).text}}</p>
            <label class="s-label"><span class="font-weight-bold">{{ $t("_BOOKING_DETAIL.ROOM.QUANTITY") }}</span></label>
            <v-text-field onkeyup="this.value=this.value.replace(/[^\d]/,'')" outlined dense v-model="roomAvai" type="number"></v-text-field>
            <v-btn class="w-100 mt-3" color="primary" @click="confirmUpdateRoomAvail()">
                {{ $t("UPDATE") }}
            </v-btn>
        </div>
    </div>
    <div id="my-batch-update" class="sidenav-search">
        <v-toolbar
          dense
          class="toolbar-update-range"
        >
          <v-btn
            icon
            light
            @click="closeUpdateRange()"
          >
            <v-icon color="grey darken-2">
              arrow_back_ios
            </v-icon>
          </v-btn>

          <v-toolbar-title class="grey--text text--darken-4 fs-15" >
            <strong>{{$t('UPDATE_ROOM_AVAILABILITY_IN_STAGES')}}</strong>
          </v-toolbar-title>
        </v-toolbar>
        <div class="h-100 content-update-range">
            <label class="pr-0 fs-10"> {{ $t("ROOM_TYPE") }} </label>
            <v-chip-group
                v-model="selectedRoomType"
                :column="true"
                multiple
                pill
                active-class="primary--text"
            >
                <v-chip filter v-for="(i, index) in listRoom.filter((x) => x.parent)"  :value="i.value" class="w-100 mb-1 mr-0">
                    {{i.text}}
                </v-chip>
            </v-chip-group>
			<!-- <v-autocomplete item-text="text" item-value="value" :items="listRoom.filter((x) => x.parent)" v-model="selectedRoomType" outlined chips dense multiple deletable-chips> -->
                <!-- <template v-slot:selection="data">
                    <v-chip
                        v-bind="data.attrs"
                        :input-value="data.selected"
                        close
                        @click="data.select"
                        @click:close="remove(data.item, selectedRoomType)"
                        >
                        {{ data.item.text }}
                    </v-chip>
                </template> -->
				<!-- <template slot="no-data">
					<div class="no-data">{{ $t("NO_DATA") }}</div>
				</template>
			</v-autocomplete> -->
            <label class="pr-0 fs-10 mt-3"> {{ $t("TIME_APPLICATION") }} </label>
            <date-picker :disabled-date="notBeforeToday" :confirm="true" :confirm-text="$t('CONFIRM')" :clearable="false"  :editable="false"
                :popup-class="'popup-calendar-mobile'" v-model="dateSelect" :lang="languageDate" :format="'DD/MM/YYYY'" 
                :shortcuts=[] range placeholder="Select date range">
            </date-picker>

            <label class="fs-10 mt-3">{{ $t("_BOOKING_DETAIL.ROOM.QUANTITY") }}</label>
            <v-text-field onkeyup="this.value=this.value.replace(/[^\d]/,'')" outlined dense v-model="roomAvaiUpdateRange"></v-text-field>
            <v-btn class="btn-update" color="primary" @click="confirmUpdateRangeRoomAvail()">
                {{ $t("UPDATE") }}
            </v-btn>
        </div>
    </div>
  </div>
</template>

<script>
import { FunctionalCalendar } from 'vue-functional-calendar';
import { sale_room } from "@/_services/SaleRoom/sale-room.js";
import { restriction } from "@/_services/SaleRoom/restriction.js";
import { service } from "@/_services/SaleRoom/room-plan.service.js";
import moment from "moment";
import { _alert } from "@/_helpers/function.js";
import DatePicker from 'vue2-datepicker';
import 'vue2-datepicker/index.css';
export default {
  components: {
      FunctionalCalendar,
      "date-picker": DatePicker,
   },
  data() {
    return {
        isLoading: true,
        selectedRoom: -1,
        listRoom: [],
        calendarConfigs: {
            dayNames: [
                `${this.$t('T2')}`,
                `${this.$t('T3')}`,
                `${this.$t('T4')}`,
                `${this.$t('T5')}`,
                `${this.$t('T6')}`,
                `${this.$t('T7')}`,
                `${this.$t('T8')}`,
            ],
            monthNames: [
                `${this.$t('TH1')}`,
                `${this.$t('TH2')}`,
                `${this.$t('TH3')}`,
                `${this.$t('TH4')}`,
                `${this.$t('TH5')}`,
                `${this.$t('TH6')}`,
                `${this.$t('TH7')}`,
                `${this.$t('TH8')}`,
                `${this.$t('TH9')}`,
                `${this.$t('TH10')}`,
                `${this.$t('TH11')}`,
                `${this.$t('TH12')}`,
            ],
            shortMonthNames: [
                `${this.$t('TH1')}`,
                `${this.$t('TH2')}`,
                `${this.$t('TH3')}`,
                `${this.$t('TH4')}`,
                `${this.$t('TH5')}`,
                `${this.$t('TH6')}`,
                `${this.$t('TH7')}`,
                `${this.$t('TH8')}`,
                `${this.$t('TH9')}`,
                `${this.$t('TH10')}`,
                `${this.$t('TH11')}`,
                `${this.$t('TH12')}`,
            ],
            disabledDates: ['beforeToday'],
        },
        relationData: [], // Thông tin gói bán và giá của tất cả phòng do API trả về
        selectedDatePicker: moment()
            .startOf("month")
            .format("YYYY-MM-DD"),
        systemLang: this.$i18n.locale,
        calendarData: {
            date: new Date()
        },
        dateUpdate: null,
        roomAvai: null,
        selectedRoomType: [],
        dateSelect: [],
        roomAvaiUpdateRange: 0,
        syncPMS: JSON.parse(localStorage.getItem("currentUser")).hotel.syncPMS,
    };
  },
  watch: { },
  mounted() {
    this.initialize();
  },
  methods: { 
    initialize() {
        const fromDateListOfPeriod = moment(new Date()).format("YYYY-MM-DD");
        const toDateListOfPeriod = moment(new Date())
            .add(1, "day")
            .format("YYYY-MM-DD");

        this.dateSelect = [new Date(fromDateListOfPeriod), new Date(toDateListOfPeriod)];
        this.getAllRoom();
    },
    loadListRoom(data) {
      this.listRoom = [];
      this.listRoom = this.listRoom.concat(
        data.map(room => {
          return {
            value: room.id,
            text: room.roomTypeI18n.find(x => x.lang === this.defaultI18n).name,
            parent: room.parent ? false : true
          };
        })
      );
      this.listRoom.sort(function(a,b) {
        var x = a.text.toLowerCase();
        var y = b.text.toLowerCase();
        return x < y ? -1 : x > y ? 1 : 0;
    });
      this.selectedRoom = this.listRoom[0].value;
      this.changeSearchCondition(this.selectedDatePicker);
    },
    getAllRoom() {
        restriction.getAllRoomTyeHasRoomRate().then((res) => {
            if (res.responseCode == 0) {
                this.loadListRoom(res.data);
            }
        });
    },
    changeSearchCondition(date) {
        var fromDate = date;
        var toDate = moment(date)
            .add(1, "M").add(-1, 'day')
            .format("YYYY-MM-DD");

        let body = {
            from: fromDate,
            to: toDate,
            roomTypeId: this.selectedRoom,
        };
        sale_room
            .getAvailability(body)
            .then(res => {
            if (res.responseCode === 0) {
                this.relationData = res.data;

                setTimeout(() => {
                    var nodeItems = document.getElementsByClassName('c-bold');
                    for (let item of nodeItems) {
                        item.parentElement.style.background = '#215675';
                        item.parentElement.style.setProperty('color', '#fff');
                    }
                    var nodeItemsNeutral = document.getElementsByClassName('c-neutral');
                    for (let item of nodeItemsNeutral) {
                        item.parentElement.style.background = '#3C8DBC';
                        item.parentElement.style.setProperty('color', '#fff');
                    }
                     var nodeItemsLight = document.getElementsByClassName('c-light');
                    for (let item of nodeItemsLight) {
                        item.parentElement.style.background = '#52a2d1';
                        item.parentElement.style.setProperty('color', '#fff');
                    }
                }, 200);
            } else {
                _alert(res, this.$t(res.data), false);
            }
            })
            .finally(() => (this.isLoading = false));
    },
    getValue(date) {
        let value = '';
        value =
            this.relationData.find(e => e.appliedDate === moment(new Date(date)).format("YYYY-MM-DD")) 
            ? this.relationData.find(e => e.appliedDate === moment(new Date(date)).format("YYYY-MM-DD")).quantity 
            : -1;
        return value;
    },
    getClass(val) {
        return val > 20 ? 'c-bold' : val >= 10 && val <= 20 ? 'c-neutral' : val > -1 ? 'c-light' : ''
    },
    chooseDate(val) {
        if (this.checkRoleFunc('INVENTORY') == false) return
        this.dateUpdate = val.date;
        this.roomAvai = this.getValue(val.date);
        if (this.listRoom.find(e => e.value === this.selectedRoom).parent === false) {
            _alert(null, this.$t('ROOM_DERIVE'), false);
            return;
        } else if (this.syncPMS) {
            _alert(null, this.$t('HOTEL_SYNC'), false);
            return;
        }
        this.openUpdate();
    },
    openUpdate() {
        document.getElementById('overlay').style.display = 'block';
        document.getElementById('overlay').style.backgroundColor = 'rgba(0, 0, 0, 0.1)';
        document.getElementById('my-update').style.top = 0;
    },
    closeNav() {
        if (document.getElementById('my-update').offsetTop === 0) {
            this.changeSearchCondition(this.selectedDatePicker);
            document.getElementById('overlay').style.display = 'none';
            document.getElementById('my-update').style.top = '-100vh';
        }
    },
    changedMonth(val) {
         this.changeSearchCondition(moment(new Date(val).setDate(1)).format("YYYY-MM-DD"));
         this.selectedDatePicker = moment(new Date(val).setDate(1)).format("YYYY-MM-DD");
    },
    confirmUpdateRoomAvail() {
        if (!this.roomAvai || this.roomAvai < 0) {
             _alert(null, this.$t("DATA_INPUT_INVALID"));
             return
        }
        const body = [
            {
                id: this.selectedRoom,
                dates: [
                    {
                        apply: moment(new Date(this.dateUpdate)).format("YYYY-MM-DD"),
                        value: this.roomAvai
                    }
                ]
            }
        ];
        service
            .updateAvailable(body)
            .then((res) => {
                _alert(res, this.$t(res.data), false);
                this.closeNav();
            })
            .finally(
                () =>
                (this.closeNav())
            );
    },
    openUpdateRange() {
        if (this.syncPMS) {
            _alert(null, this.$t('HOTEL_SYNC'), false);
            return;
        }
        document.getElementById('overlay').style.display = 'block';
        document.getElementById('overlay').style.backgroundColor = 'rgba(0, 0, 0, 0.1)';
        document.getElementById('my-batch-update').style.top = 0;
    //    document.getElementById('my-batch-update').style.bottom = 0;
       this.selectedRoomType = [this.listRoom.filter(e => e.parent)[0].value];
       this.roomAvaiUpdateRange = 0;
    },
    closeUpdateRange() {
        // document.getElementById('my-batch-update').style.bottom = '-100vh';
        document.getElementById('my-batch-update').style.top = '-100vh';
         document.getElementById('overlay').style.display = 'none';
    },
    confirmUpdateRangeRoomAvail() {
        var dateValue = [];
        let fromDate = moment(this.dateSelect[0], "YYYY/MM/DD");
        let toDate = moment(this.dateSelect[1], "YYYY/MM/DD");
        if (this.get_day_of_time(new Date(this.dateSelect[0]), new Date(this.dateSelect[1])) > 365) {
            _alert(null, this.$t("UPDATE_INTERVAL_IS_NOT_MORE_THAN_ONE_YEAR"));
            return true
        }
        while (fromDate <= toDate) {
            dateValue.push({
                apply: fromDate.format("YYYY-MM-DD"),
                value: this.roomAvaiUpdateRange,
            });
            fromDate = moment(fromDate).add(1, "day");
        }

        let body = [];
        if (this.selectedRoomType.length > 0 && dateValue.length > 0 && this.roomAvaiUpdateRange !== '' && +this.roomAvaiUpdateRange >= 0) {
            this.selectedRoomType.forEach((x) => {
                body.push({
                    id: x,
                    dates: dateValue,
                });
            });
            service
            .updateAvailable(body)
            .then((res) => {
                _alert(res, this.$t(res.data), false);
                if (res.responseCode === 0) {
                    this.closeUpdateRange();
                    this.changeSearchCondition(this.selectedDatePicker);
                }
            })
            .finally(
                () => {
                    this.closeUpdateRange();
                    this.changeSearchCondition(this.selectedDatePicker);
                }
            );
        } else {
            _alert(null, this.$t("DATA_INPUT_INVALID"));
        }
    },
    remove (item, arr) {
        const index = arr.indexOf(item.value)
        if (index >= 0) arr.splice(index, 1)
    },
    _moment: moment
  }
};
</script>
